/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Guide_SchemaInputs */

const en_sidebar_guide_schema = /** @type {(inputs: Sidebar_Guide_SchemaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Schema`)
};

const ko_sidebar_guide_schema = /** @type {(inputs: Sidebar_Guide_SchemaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Schema`)
};

const ja_sidebar_guide_schema = /** @type {(inputs: Sidebar_Guide_SchemaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Schema`)
};

/**
* | output |
* | --- |
* | "JSON Schema" |
*
* @param {Sidebar_Guide_SchemaInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sidebar_guide_schema = /** @type {((inputs?: Sidebar_Guide_SchemaInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Guide_SchemaInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sidebar_guide_schema(inputs)
	if (locale === "ko") return ko_sidebar_guide_schema(inputs)
	return ja_sidebar_guide_schema(inputs)
});